import { render, staticRenderFns } from "./RatingsTotal.vue?vue&type=template&id=13ffe2b2"
import script from "./RatingsTotal.vue?vue&type=script&lang=js"
export * from "./RatingsTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports